import { render, staticRenderFns } from "./QuotesView.vue?vue&type=template&id=35f5db88&"
import script from "./QuotesView.vue?vue&type=script&lang=ts&"
export * from "./QuotesView.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports